import { render, staticRenderFns } from "./GestionPlantillasEmail.vue?vue&type=template&id=44ac74fe&"
import script from "./GestionPlantillasEmail.vue?vue&type=script&lang=js&"
export * from "./GestionPlantillasEmail.vue?vue&type=script&lang=js&"
import style0 from "./GestionPlantillasEmail.vue?vue&type=style&index=0&id=44ac74fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports